export const GTM_CONTAINER_ID = String(process.env.GATSBY_GTM_CONTAINER_ID);

export const APP_NAME = String(process.env.APP_NAME);
export const SITE_NAME = String(process.env.SITE_NAME);
export const BUILD_ID = String(process.env.BUILD_ID);
export const NODE_ENV = String(process.env.NODE_ENV);
